import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CreditCardIcon from '../CreditCardIcon';

const CreditCard = ({ className, creditCard }) =>
  creditCard ? (
    <div className={classNames('payment-section__card', className)}>
      <div className="payment-section__card-provider-icon">
        <CreditCardIcon cardType={creditCard.cardType} />
      </div>
      <div className="payment-section__card-user">
        <div className="payment-section__card-user-name">
          {creditCard.cardholderName}
        </div>
        <div className="payment-section__card-user-card-number">
          ****{creditCard.lastFour}
        </div>
      </div>
    </div>
  ) : null;

CreditCard.defaultProps = {
  className: '',
};

CreditCard.propTypes = {
  className: PropTypes.string,
  creditCard: PropTypes.shape({
    cardType: PropTypes.string.isRequired,
    cardholderName: PropTypes.string.isRequired,
    lastFour: PropTypes.string.isRequired,
  }).isRequired,
};

export default CreditCard;
